// extracted by mini-css-extract-plugin
var _1 = "VersionChangeCard-module__animateUploadProgressBarWidth--SrFVR";
var _2 = "VersionChangeCard-module__animatedBackground--GEF4g";
var _3 = "VersionChangeCard-module__authorName--kADvq";
var _4 = "VersionChangeCard-module__badge--HOR_u";
var _5 = "VersionChangeCard-module__compactAvatarContainer--vJFVo";
var _6 = "VersionChangeCard-module__content--w7Z7r";
var _7 = "VersionChangeCard-module__contentContainer--mzsEg";
var _8 = "VersionChangeCard-module__copyLinkButton--i2BTM";
var _9 = "VersionChangeCard-module__copyLinkButtonIcon--HV49p";
var _a = "VersionChangeCard-module__date--_KEAE";
var _b = "VersionChangeCard-module__focused--ajn6e";
var _c = "VersionChangeCard-module__menuContainer--x2NCB";
var _d = "VersionChangeCard-module__newBadgeContainer--l4O05";
var _e = "VersionChangeCard-module__open--a7BBZ";
var _f = "VersionChangeCard-module__popOverRoot--nqb7x";
var _10 = "VersionChangeCard-module__popOverRootInner--wPmnz";
var _11 = "VersionChangeCard-module__root--vC49Z";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "authorName", _4 as "badge", _5 as "compactAvatarContainer", _6 as "content", _7 as "contentContainer", _8 as "copyLinkButton", _9 as "copyLinkButtonIcon", _a as "date", _b as "focused", _c as "menuContainer", _d as "newBadgeContainer", _e as "open", _f as "popOverRoot", _10 as "popOverRootInner", _11 as "root" }
